module.exports = __webpack_public_path__ + "img/icon_re_white.3744a79d.png";